import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute, Data } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import {TranslateService} from "@ngx-translate/core";
import { environment } from 'src/environments/environment';
import { VerticalSidebarService } from '../vertical-sidebar/vertical-sidebar.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit {
  pageInfo: Data = Object.create(null);
  environment = environment;
  path
  percorso: string [] = [];
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translate: TranslateService,
    private menuServise: VerticalSidebarService,
    private route: ActivatedRoute
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter(route => route.outlet === 'primary'))
      .pipe(mergeMap(route => route.data))
      .subscribe(event => {
        this.titleService.setTitle(event['title'] ? this.translate.instant(event['title'] ): "");
        this.pageInfo = event;
      });
  }
  findMenuPath(menu, targetPath) {
    for (const item of menu) {
      if (item.path?.replace(/\//gi, '') == targetPath?.replace(/\//gi, '')) {
        return [item.title];
      }

      if (item.submenu) {
        const subPath = this.findMenuPath(item.submenu, targetPath);
        if (subPath) {
          return [item.title, ...subPath];
        }
      }
    }

    return null;
  }
  ngOnInit() { 
    this.menuServise?.items?.subscribe(menuItems => {
      var menus = menuItems;
      this.router.events.subscribe(() => {
        this.percorso = this.findMenuPath(menus, this.router?.url) ?? [];
        this.path = this.findMenuPath(menus, this.router?.url)?.join(' -> ') ?? '';
      })
    });
  }
}
